import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const LoadingSpinner: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        bgcolor: '#0A0A0A',
        color: 'white',
      }}
    >
      <CircularProgress
        size={48}
        sx={{
          color: '#FFD700',
          mb: 2,
        }}
      />
      <Typography variant="body1" sx={{ color: '#888' }}>
        Loading...
      </Typography>
    </Box>
  );
};

export default LoadingSpinner;